import axios from "axios";

// config
const request = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_BASEURL,
});

const headers = (header) => {
  return {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("api_key")}`,
      ...(header && header),
    },
  };
};

const getHotelId = () => {
  return localStorage.getItem("hotel_id");
};

const querystring = (query) => {
  return {
    params: query,
  };
};

/* 
  API Title		  네트워크 도어락 목록 조회
  API Path		  /hotels/:hotel_id/network-doorlocks
  API Method		GET
  CREATE DATE   2025.06.19
  AUTHOR        LUKA
*/
export const listNetworkDoorLock = ({
  buildingId: building_id, // 빌딩 ID
  floorId: floor_id, // 층 ID
  name, // 도어락 이름(객실 번호)
  serial, // 시리얼 넘버
  type, // 도어락 타입
  status, // 도어락 상태
  fwType: fw_type, // 모델명
  fwVersion: fw_version, // 모델 버전
  sort,
  order,
  offset = 0, // default - 0
  limit = 3000, // default - 3000
  pagination = true, // default - true
}) => {
  return request.get(`/multifamily/hotels/${getHotelId()}/network-doorlocks`, {
    ...querystring({
      ...(building_id && { building_id }),
      ...(floor_id && { floor_id }),
      ...(name && { name }),
      serial,
      ...(type && { type }),
      ...(status && { status }),
      ...(fw_type && { fw_type }),
      ...(fw_version && { fw_version }),
      ...(sort && { sort }),
      ...(order && { order }),
      offset,
      limit,
      pagination,
    }),
    ...headers(),
  });
};

/* 
  API Title		  네트워크 도어락 상세 조회
  API Path		  /hotels/:hotel_id/network-doorlocks/:doorlock_id
  API Method		GET
  CREATE DATE   2025.06.19
  AUTHOR        LUKA
*/
export const listDetailNetworkDoorLock = ({ doorlock_id }) => {
  return request.get(
    `/multifamily/hotels/${getHotelId()}/network-doorlocks/${doorlock_id}`,
    {
      ...querystring({}),
      ...headers(),
    }
  );
};

/* 
  API Title		  네트워크 도어락 상태 제어 프레임 넘버 조회
  API Path		  /hotels/:hotel_id/network-doorlocks/:doorlock_id/status-control-frame_number
  API Method	  GET
  UPDATE DATE   2025.07.24
  AUTHOR        LUKA
*/
export const listDetailNetworkDoorFrameNumber = ({ doorlock_id }) => {
  return request.get(
    `/multifamily/hotels/${getHotelId()}/network-doorlocks/${doorlock_id}/status-control-frame_number`,
    {
      ...querystring({}),
      ...headers(),
    }
  );
};

/* 
  API Title		  상태 로그 조회
  API Path		  /hotels/:hotel_id/network-doorlocks/:doorlock_id/status-logs
  API Method		GET
  CREATE DATE   2025.06.19
  AUTHOR        LUKA
*/
export const getStatusLogs = ({
  doorlockId: doorlock_id,
  offset = 0, // default - 0
  limit = 30, // default - 30
  pagination = true, // default - true
  startAt: start_at, // EX) 2025-06-17T15:00:00.000Z
  endAt: end_at, // EX) 2025-06-17T15:00:00.000Z
}) => {
  return request.get(
    `/multifamily/hotels/${getHotelId()}/network-doorlocks/${doorlock_id}/status-logs`,
    {
      ...querystring({
        ...(start_at && { start_at }),
        ...(end_at && { end_at }),
        offset,
        limit,
        pagination,
      }),
      ...headers(),
    }
  );
};

/* 
  API Title		  제어 로그 조회
  API Path		  /hotels/:hotel_id/network-doorlocks/:doorlock_id/control-logs
  API Method		GET
  CREATE DATE   2025.06.19
  AUTHOR        LUKA
*/
export const getControlLogs = ({
  doorlockId: doorlock_id,
  offset = 0, // default - 0
  limit = 30, // default - 30
  pagination = true, // default - true
  startAt: start_at, // EX) 2025-06-17T15:00:00.000Z
  endAt: end_at, // EX) 2025-06-17T15:00:00.000Z
}) => {
  return request.get(
    `/multifamily/hotels/${getHotelId()}/network-doorlocks/${doorlock_id}/control-logs`,
    {
      ...querystring({
        ...(start_at && { start_at }),
        ...(end_at && { end_at }),
        offset,
        limit,
        pagination,
      }),
      ...headers(),
    }
  );
};

/* 
  API Title		  frame 카운터 업데이트
  API Path		  /hotels/:hotel_id/network-doorlocks/:doorlock_id/frame_number
  API Method		PUT
  CREATE DATE   2025.06.19
  AUTHOR        LUKA
*/
export const updateFrameCount = ({ doorlock_id }) => {
  return request.put(
    `/multifamily/hotels/${getHotelId()}/network-doorlocks/${doorlock_id}/frame_number`,
    {},
    headers()
  );
};

/* 
  API Title		  락아웃 (카드키) 시퀀스 넘버 카운트 + 1
  API Path		  /hotels/:hotel_id/network-doorlocks/room_id/:room_id
  API Method		GET
  CREATE DATE   2025.08.01
  AUTHOR        LUKA
*/
export const updateCardGuestSeqNum = ({ room_id }) => {
  return request.get(
    `/multifamily/hotels/${getHotelId()}/network-doorlocks/room_id/${room_id}`,
    {
      ...querystring({}),
      ...headers(),
    }
  );
};

/* 
  API Title		  락아웃 (핀코드) 시퀀스 넘버 카운트 + 1
  API Path		  /hotels/:hotel_id/network-doorlocks/room_id/:room_id
  API Method		GET
  CREATE DATE   2025.08.01
  AUTHOR        LUKA
*/
export const updatePinGuestSeqNum = ({ room_id }) => {
  return request.get(
    `/multifamily/hotels/${getHotelId()}/network-doorlocks/room_id/pin/${room_id}`,
    {
      ...querystring({}),
      ...headers(),
    }
  );
};
